import { render, staticRenderFns } from "./MonthlyUserMore.vue?vue&type=template&id=fa462c06"
import script from "./MonthlyUserMore.vue?vue&type=script&lang=js"
export * from "./MonthlyUserMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports